module.exports = __webpack_public_path__ + "static/media/item_6_36_comp.4ada663d.png";